import React, { useContext } from 'react';

const TemplateContext = React.createContext(null);

export default TemplateContext;

export function useTemplateContext() {
    return useContext(TemplateContext);
}
